export default __webpack_public_path__ + "static/media/shareEn1.34ab716d.jpg";